import basic from './basic';
import directory from './directory';
import check from './check';
import document from './document';
import statistics from './statistics';

export default {
    basic,
    directory,
    check,
    document,
    statistics
}